export default __webpack_public_path__ + "static/media/whitepapernine.2df7a94e.png";